import { ISelectOption } from "../types/select";
import { lastYears } from "./yearsMocker";

const LOCAL_STORAGE_KEY = "selectedYear";

export const getInitialSelectedYearFromLocalStorage = (): ISelectOption => {
  const storedYear = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (storedYear) {
    const yearValue = Number(storedYear);
    if (!isNaN(yearValue)) {
      return { label: storedYear, value: yearValue };
    }
  }
  return lastYears[0];
};

export const setSelectedYearToLocalStorage = (yearOption: ISelectOption): void => {
  localStorage.setItem(LOCAL_STORAGE_KEY, String(yearOption.value));
};

export const clearSelectedYearFromLocalStorage = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};
